import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Mainpage from "./pages/Mainpage";
import Conflo from "./pages/Conflo";
import Rojokam from "./pages/Rojokam";
import Rikpak from "./pages/Rikpak";
import Sienepmc from "./pages/Sienepmc";
import Siendci from "./pages/Siendci";
import UnderConstruction from "./components/UnderConstruction";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Mainpage />} />
        <Route path="/Conflo" element={<Conflo />} />
        <Route path="/Rojokam" element={<Rojokam />} />
        <Route path="/Rikpak" element={<Rikpak />} />
        <Route path="/Sienepmc" element={<Sienepmc />} />
        <Route path="/Siendci" element={<Siendci />} />
        <Route path="*" element={<UnderConstruction />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
